const API_HOST = window.BASE_URL ? window.BASE_URL : process.env.VUE_APP_HOSTNAME
const GA_ID = window.GA_ID ? window.GA_ID : process.env.VUE_APP_GA_ID
const GTM_ID = window.GTM_ID ? window.GTM_ID : process.env.VUE_APP_GTM_ID

export const TITLE = window.TITLE ? window.TITLE : process.env.VUE_APP_TITLE

export { GA_ID, GTM_ID, API_HOST }
